export const SET_USER_LOGGED_IN = 'SET_USER_LOGGED_IN'
export const SET_USER_AUTH_DATA = 'SET_USER_AUTH_DATA'
export const RESET_STATE = 'RESET_STATE'
export const SET_KYC_AND_SETTLEMENT = "SET_KYC_AND_SETTLEMENT";